export {
  addEvent,
  getOwnerDocument,
  getOwnerWindow,
  isShadowRoot
} from '../../../src/utils/domHelpers';
